import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/store/store';

export type GameWindowHelperDataState = {
  errorCorrelationId: string | null;
};

const initialState: GameWindowHelperDataState= {
  errorCorrelationId: null,
};

const reducers = {
    setErrorCorrelationId: (state, action: PayloadAction<string | null>) => {
      state.errorCorrelationId = action.payload;
    },
};

const gameWindowHelperData = createSlice({
  name: 'gameWindowHelperData',
  initialState,
  reducers,
});

export const gameWindowHelperDataSelector = (state: RootState) =>
  state.gameWindowHelperData.errorCorrelationId;

export const { setErrorCorrelationId } = gameWindowHelperData.actions;
export const gameWindowHelperDataReducer = gameWindowHelperData.reducer;
